if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
        this.updatePagination();
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          const mediaList = activeMedia.parentElement;
          const previousScrollBehavior = mediaList.style.scrollBehavior;
          if (currentVariant) mediaList.style.scrollBehavior = 'auto';
          mediaList.scrollTo({ left: activeMedia.offsetLeft });
          if (currentVariant) {
            window.requestAnimationFrame(() => {
              mediaList.style.scrollBehavior = previousScrollBehavior;
            });
            if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              activeMedia.animate?.([{ opacity: 0.25 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
            }
          }
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
      window.ZoriaCarouselFocus?.schedule();
    }

    updatePagination() {
      const visibleSlides = this.querySelectorAll('.product__media-item:not(.hidden)');
      const visibleDots = this.querySelectorAll('.slider-counter__link:not(.hidden)');
      const total = visibleSlides.length;

      this.elements.viewer.querySelector('.slider-buttons')?.classList.toggle('small-hide', total <= 1);
      const totalElement = this.elements.viewer.querySelector('.slider-counter--total');
      if (totalElement) totalElement.textContent = total;

      visibleDots.forEach((dot, index) => {
        dot.setAttribute('aria-label', `${this.dataset.loadSlideLabel} ${index + 1} ${this.dataset.ofLabel} ${total}`);
      });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

(() => {
  const listenerKey = '__zoriaProductGalleryArrowListener';
  if (window[listenerKey]) return;
  window[listenerKey] = true;

  const visibleMedia = (gallery) => Array.from(
    gallery.querySelectorAll('[id^="Slider-Gallery-"] > .product__media-item:not(.hidden)')
  );

  const setFallbackActiveMedia = (gallery, media, position, total) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const mediaList = media.parentElement;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    mediaList.querySelectorAll(':scope > [data-media-id]').forEach((item) => {
      item.classList.toggle('is-active', item === media);
    });
    mediaList.scrollTo({
      left: media.offsetLeft,
      behavior: reducedMotion ? 'auto' : 'smooth',
    });

    const thumbnail = gallery.querySelector(`[data-target="${CSS.escape(media.dataset.mediaId)}"]`);
    gallery.querySelectorAll('[id^="GalleryThumbnails-"] button[aria-current]').forEach((button) => {
      button.removeAttribute('aria-current');
    });
    thumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');

    const current = viewer?.querySelector('.slider-counter--current');
    const totalElement = viewer?.querySelector('.slider-counter--total');
    if (current) current.textContent = position;
    if (totalElement) totalElement.textContent = total;

    viewer?.dispatchEvent(new CustomEvent('slideChanged', {
      detail: { currentElement: media, currentPage: position },
    }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      'media-gallery [id^="GalleryViewer-"] > .slider-buttons button[name="next"], media-gallery [id^="GalleryViewer-"] > .slider-buttons button[name="previous"]'
    );
    if (!button || button.disabled) return;

    const gallery = button.closest('media-gallery');
    if (!gallery) return;
    const mediaItems = visibleMedia(gallery);
    if (mediaItems.length < 2) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const activeIndex = Math.max(0, mediaItems.findIndex((item) => item.classList.contains('is-active')));
    const nextIndex = button.name === 'next'
      ? Math.min(mediaItems.length - 1, activeIndex + 1)
      : Math.max(0, activeIndex - 1);
    const nextMedia = mediaItems[nextIndex];
    if (!nextMedia) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(nextMedia.dataset.mediaId, false);
    } else {
      setFallbackActiveMedia(gallery, nextMedia, nextIndex + 1, mediaItems.length);
    }

    const controls = gallery.querySelector('[id^="GalleryViewer-"] > .slider-buttons');
    const previous = controls?.querySelector('button[name="previous"]');
    const next = controls?.querySelector('button[name="next"]');
    if (previous) previous.disabled = nextIndex === 0;
    if (next) next.disabled = nextIndex === mediaItems.length - 1;
  }, true);
})();
